import { MsSort as m, MsSettings as s } from "@sunrise/icons";
import { screenSizeDetection as u } from "@sunrise/shared";
import { defineComponent as f, ref as k } from "vue";
import p from "./index11.js";
import S from "./index43.js";
const b = f({
  name: "CsFilterBar",
  components: {
    CsStickyContainer: S,
    CsBookmarkIcon: p,
    MsSettings: s,
    MsSort: m
  },
  props: {
    maxScrollDepth: Number,
    amountOfFilter: Number,
    showBookmarks: Boolean,
    filterColor: String,
    hasDot: Boolean,
    amountOfResults: String,
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["click:bookmark", "click:filter", "update:modelValue"],
  setup(C, { emit: o }) {
    const { isScreenM: r } = u(), e = k(!1);
    function n(t) {
      e.value = t;
    }
    function i() {
      o("click:bookmark");
    }
    function a() {
      o("click:filter");
    }
    function c(t) {
      const l = t.target;
      o("update:modelValue", l.value);
    }
    return {
      isScreenM: r,
      isSticky: e,
      onStickyChange: n,
      onClickBookmark: i,
      onClickFilter: a,
      onSortChange: c
    };
  }
});
export {
  b as default
};
